import React, { Component } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import Slider from "rc-slider";
import { Redirect } from "react-router";

import "rc-slider/assets/index.css";
import "../../static/style/dashboard.css";
import "../../static/style/slider.css";
import Button from "../../components/Button";
import { fetchPlan, setDue } from "../../actions/index";

class Plan extends Component {
  constructor(props, context) {
    super(props, context);

    this.setMonthly = this.setMonthly.bind(this);
    this.setPlan = this.setPlan.bind(this);
    this.changeDue = this.changeDue.bind(this);
    this.toggleChange = this.toggleChange.bind(this);
    this.setPartSlider = this.setPartSlider.bind(this);

    this.state = {
      redirect: false,
      anime: "",
      isChecked: false
    };
  }

  toggleChange() {
    this.setState({
      isChecked: !this.state.isChecked,
      due: 31
    });
    this.setState({ due: 31 });
    this.setPlan(this.state.debt, this.state.part, 31);
    this.props.setDue(31);
  }

  changeDue(due) {
    let x = due.target.value;

    if (x < 1) {
      x = 1;
    }
    if (x > 31) {
      x = 31;
    }
    this.setState({ due: x });
    this.setPlan(this.state.debt, this.state.part, x);
    this.props.setDue(x);
  }

  setPlan(i, parts, due) {
    this.props.fetchPlan(i.id, parts, due);
  }

  setPartSlider(part) {
    this.setState({
      part: part
    });
  }

  setMonthly(part) {
    this.setPlan(this.state.debt, part, this.state.due);
    this.setState({
      part: part,
      anime: "anim"
    });

    setTimeout(() => {
      this.setState({ anime: "" });
    }, 500);
  }

  componentDidMount() {
    let redirect = false;

    if (!this.props.debts) {
      redirect = true;
    }

    if (!redirect) {
      const find_id = this.props.match.params.id;
      let debt = null;

      for (let find of this.props.debts) {
        if (Number(find.id) === Number(find_id)) {
          debt = find;
          break;
        }
      }

      if (debt) {
        let imin = 2;
        let imax = 6;
        let steps = 1;
        const due = 15;
        /*
New boundaries from Brang @ 10.9.2018
Pääoma	Min erä	Max. Erä / tarkistettu
100	2	2
150	2	3
200	2	5
250	2	7
300	2	8
350	2	9
400	2	10
450	2	11
500	2	12
550	2	13
600	2	14
650	2	15
700	2	16
750	2	16
800	2	16
850	2	16
900	2	16
950	2	17
1000	2	18
1200	2	21
1400	2	24
1600	2	28
1800	2	28
2000	2	36
 */
        // How many payments:
        if (debt.avoinna > 2000) {
          imin = 2;
          imax = 36;
        } else if (debt.avoinna >= 1800) {
          imin = 2;
          imax = 28;
        } else if (debt.avoinna >= 1400) {
          imin = 2;
          imax = 24;
        } else if (debt.avoinna >= 1200) {
          imin = 2;
          imax = 21;
        } else if (debt.avoinna >= 1000) {
          imin = 2;
          imax = 18;
        } else if (debt.avoinna >= 950) {
          imin = 2;
          imax = 17;
        } else if (debt.avoinna >= 900) {
          imin = 2;
          imax = 16;
        } else if (debt.avoinna >= 650) {
          imin = 2;
          imax = 13;
        } else if (debt.avoinna >= 600) {
          imin = 2;
          imax = 12;
        } else if (debt.avoinna >= 550) {
          imin = 2;
          imax = 11;
        } else if (debt.avoinna >= 500) {
          imin = 2;
          imax = 10;
        } else if (debt.avoinna >= 450) {
          imin = 1;
          imax = 9;
        } else if (debt.avoinna >= 400) {
          imin = 2;
          imax = 8;
        } else if (debt.avoinna >= 350) {
          imin = 2;
          imax = 7;
        } else if (debt.avoinna >= 300) {
          imin = 2;
          imax = 6;
        } else if (debt.avoinna >= 250) {
          imin = 2;
          imax = 5;
        } else if (debt.avoinna >= 200) {
          imin = 2;
          imax = 4;
        } else if (debt.avoinna >= 150) {
          imin = 2;
          imax = 3;
        } else if (debt.avoinna >= 100) {
          imin = 2;
          imax = 2;
        }

        let parts = Math.round(imax / 2);

        // Initial value for installments choice shouldn't be below minimum
        if (parts < imin) {
          parts = imin;
        }

        this.setPlan(debt, parts, due);

        this.setState({
          debt: debt,
          imin: imin,
          imax: imax,
          part: parts,
          steps: steps,
          due: due
        });

        this.props.setDue(due);
      } else {
        redirect = true;
      }
    }

    this.setState({
      redirect: redirect
    });
  }

  render() {
    if (this.state.redirect === true) {
      return <Redirect to="/" />;
    }

    const debt = this.state.debt;
    const plan = this.props.plan.plan;

    if (debt && plan) {
      return (
        <div className="row">
          <div className={"col-sm-12"}>
            <h1 className="header1">
              <FormattedMessage
                id="app.plan.new"
                defaultMessage="Tee uusi osamaksusopimus"
              />
            </h1>
            <div className={"card"}>
              <div className="card-body">
                <div className="row">
                  <div className="col-8">
                    <h3 className="card-title">{debt.paamies.nimi}</h3>
                    <h6 className="card-subtitle mb-2 ass-card-guide-s">
                      <FormattedMessage
                        id="app.dashcard.case_no"
                        defaultMessage="Asianumero"
                      />: {debt.nro}
                    </h6>
                  </div>
                  <div className="col-4 text-right">
                    <p className="ass-card-guide">
                      <FormattedMessage
                        id="app.dashcard.sum"
                        defaultMessage="Avoin summa"
                      />
                    </p>
                    <p className="ass-card-price">{debt.avoinna} €</p>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-12">
                    <h4 className="ass-card-price">
                      <FormattedMessage
                        id="app.plan.monthly"
                        defaultMessage="Erien määrä"
                      />
                    </h4>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-6">
                    <Slider
                      className={"debt-slider"}
                      step={this.state.steps}
                      defaultValue={this.state.part}
                      onAfterChange={this.setMonthly}
                      onChange={this.setPartSlider}
                      min={this.state.imin}
                      max={this.state.imax}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6">
                    <h2 className={this.state.anime + " ass-card-guide-l"}>
                      {" "}
                      {this.state.part}{" "}
                      <FormattedMessage
                        id="app.plan.monthly_payment"
                        defaultMessage="erää"
                      />
                    </h2>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <p className={" ass-card-guide"}>
                      <FormattedMessage
                        id="app.plan.monthly_sum"
                        defaultMessage="Erän summa €/kk"
                      />
                    </p>
                    <p className={this.state.anime + " ass-card-price-l"}>
                      {plan.maksusopimusera_erittely[0].summa}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <p className="ass-card-guide">
                      <FormattedMessage
                        id="app.plan.interest"
                        defaultMessage="Kulut ja korot"
                      />
                    </p>
                    <p className="ass-card-price">
                      {Number(
                        Math.round(plan.summa - debt.avoinna + "e2") + "e-2"
                      )}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <p className="ass-card-guide">
                      <FormattedMessage
                        id="app.plan.total"
                        defaultMessage="Maksettava yhteensä"
                      />
                    </p>
                    <p className="ass-card-price">{plan.summa}</p>
                    <hr />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <p className="ass-card-price">
                      <FormattedMessage
                        id="app.dashcard.due_date"
                        defaultMessage="Eräpäivä"
                      />
                    </p>
                    <p className="ass-card-guide">
                      <FormattedMessage
                        id="app.plan.due_date_month"
                        defaultMessage="Kuukauden "
                      />
                      <input
                        type="number"
                        min="1"
                        max="31"
                        maxLength="2"
                        pattern="\d*"
                        value={this.state.due}
                        onChange={this.changeDue}
                      />
                      <FormattedMessage
                        id="app.plan.due_date_day"
                        defaultMessage="Päivä"
                      />
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <input
                      type="checkbox"
                      checked={this.state.isChecked}
                      onChange={this.toggleChange}
                    />
                    <p className="ass-card-guide">
                      <FormattedMessage
                        id="app.plan.due_day_last"
                        defaultMessage="Haluan että eräpäivä on aina kuun viimeinen päivä"
                      />
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <hr />
                    <Button
                      btnText={
                        <FormattedMessage
                          id="button.lbl.next"
                          defaultMessage="SEURAAVA"
                        />
                      }
                      btnStyle="primary"
                      btnPath={"/plan-deal/" + debt.id}
                    />
                    <Button
                      btnText={
                        <FormattedMessage
                          id="button.lbl.cancel"
                          defaultMessage="PERUUTA"
                        />
                      }
                      btnStyle="secondary"
                      btnPath={"/dashboard"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return "Loading...";
    }
  }
}

const mapStateToProps = function(store) {
  return {
    debts: store.debts.debts,
    plan: store.plan
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchPlan: (id, parts, due) => dispatch(fetchPlan(id, parts, due)),
    setDue: due => dispatch(setDue(due))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Plan);



// WEBPACK FOOTER //
// ./src/containers/PaymentPlan/Plan.js